import { render, staticRenderFns } from "./MesLists.vue?vue&type=template&id=37967c27&scoped=true"
import script from "./MesLists.vue?vue&type=script&lang=js"
export * from "./MesLists.vue?vue&type=script&lang=js"
import style0 from "./MesLists.vue?vue&type=style&index=0&id=37967c27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37967c27",
  null
  
)

export default component.exports